import React from 'react';
import AcademicManagement from '../academic-management';

const ProgramUnitManagementSystem = () => {
    return <AcademicManagement embedded={false} />;
};

export default ProgramUnitManagementSystem;
